import {InnerItem} from "./InnerItem";
import swipeImage from "../images/swipe_icon.png";
import filterImage from "../images/producer_filter_icon.png";
import cutDownImage from "../images/cut_down_icon.png";
import manageImage from "../images/manage_icon.png";
import findImage from "../images/find_icon.png";
import chatImage from "../images/chat_icon.png";
import allSkillsImage from "../images/all_skils_icon.png";


const producers: InnerItem[] = [
    {    
        title: "Swipe",
        content: "Quickly swipe through actors in your city to fill your roles",
        image: swipeImage,
    },
    {
        title: "Filter",
        content: "Use filters (age, gender, location) for a more efficient search",
        image: filterImage,
    },
    {
        title: "Cut down",
        content: "Cut down on unwanted communication - only producers can initiate the conversation ",
        image: cutDownImage,
    },
    {
        title: "Manage",
        content: "Easily manage all your roles and projects",
        image: manageImage,
    },
]

const actors: InnerItem[] = [
    {
        title: "Swipe",
        content: "Swipe through projects in your area to find what interests you",
        image: swipeImage,
    },
    {
        title: "Find",
        content: "Find roles in  short-films, commercials, music videos, and even feature films",
        image: findImage,
    },
    {
        title: "Chat",
        content: "Safer interactions with producers - conducted via in-app chat",
        image: chatImage,
    },
    {
        title: "All skill levels",
        content: "All skill levels welcome - no experience or agent required",
        image: allSkillsImage,
    },
]

export default { producers, actors }